export default __webpack_public_path__ + "static/graphic_job-profile_small-832c293fccf0ebac16025ae9037c2269.png";